<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-15 16:14:07
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:15:31
 * @name: 主页-导航侧边栏
 * @Description: 主页-导航侧边栏
 * @FilePath: \project\src\components\index\index-router-link.vue
 * @Author: desktop
-->
<template>
  <div class="indexRouterLink">
    <div class="container">
      <div
        class="part"
        v-for="itemX of indexView.indexRouterLinkConfig"
        :key="itemX.label"
      >
        <font class="label">{{ itemX.label }}</font>
        <div class="list">
          <div class="item" v-for="itemY of itemX.children" :key="itemY.label" :class="{actived: itemY.url === indexView.indexRouterLinkActive}" @click="activedChange(itemY)">
            <img class="icon" :src="itemY.icon"/>
            <font class="text">{{itemY.label}}</font>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounceation } from '@/utils/decorator';
export default {
  props: {
    indexView: {
      type: Object,
    },
  },
  name: "indexRouterLink",
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击导航栏
     * @param {Object} item 点击项
     */    
    @debounceation(300)
    activedChange(item) {
      this.indexView.activedChange(item.url);
    }
  }
};
</script>
<style lang="scss" scoped>
.indexRouterLink {
  width: 220px;
  height: 100%;
  border-right: 1px solid $Vars-border-first-color;
  flex-shrink: 0;
  box-sizing: border-box;
  overflow-y: auto;
  .container {
    padding: 20px 0;
    @extend .et-flex-column-normal;
    .part {
      width: 100%;
      @extend .et-flex-column-normal;
      .label {
        padding: 10px;
        font-size: $Vars-font-miniTitle-size;
        color: $Vars-font-important-color;
      }
      .list {
        width: 100%;
        @extend .et-flex-column-normal;
        .item {
          width: 100%;
          box-sizing: border-box;
          padding: 20px 30px;
          @extend .et-flex-start;
          @extend .et-clickElement;
          &:hover,&.actived {
            background: $Vars-background-single-gray;
          }
          .icon {
            width: 16px;
            height: 16px;
            margin-right: 10px;
          }
          .text {
            font-size: $Vars-font-content-size;
            color: $Vars-font-secondary-color;
          }
        }
      }
    }
  }
}
</style>